import { useEditor } from '@craftjs/core';

import { useIsDraggingExternal } from '../BlockEditor.context';

/**
 * Hook to detect if any node is currently being dragged in the craft.js editor.
 * Useful for showing visual feedback on drop zones during drag operations.
 *
 * @returns boolean indicating if a node is being dragged
 */
export function useIsDragging(): boolean {
  const { isDraggingExternal } = useIsDraggingExternal();
  const { isDragging } = useEditor((state) => ({
    isDragging: state.events.dragged.size > 0,
  }));

  return isDragging || isDraggingExternal;
}
